import HiggsPromise from '../../utils/higgsPromise';

/* 财务画像-财务舞弊分析-获取造假分析数据
 * POST请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
*/
export function queryFraudAnalysis(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/analysis',
        data: data
    });
}

// 财务舞弊动机列表
export function queryFraudMotive(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/motivate/list',
        data: data
    });
}

// 财务舞弊表象提示列表
export function fraundSurfaceTip(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/tips/list',
        data: data
    });
}

// 一年亏损一年赢利、 长期投资异常变动、税费异常
export function netProfit(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/tips/detail',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/financialPicture/fraudAnalysis.js